module.exports = __webpack_public_path__ + "img/check.17b618d1.png";